import { SingleActionConfig } from "../SingleActionConfig";
import { ExpandedAction } from "../../Action";

export abstract class NoDatabaseActionActionConfig extends SingleActionConfig {
  protected constructor(action: ExpandedAction) {
    super(action, [], false);
  }
  getClickPhrase = () => "";
}
